/****************************************************
 * Module Name:  documentMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React from "react";
import { useTheme } from "@mui/material/styles";
import { Modal } from "react-bootstrap";
import { AppBar, Box, Tab, Tabs, Typography, Tooltip } from "@mui/material";
import { PlagiarismRounded, UploadFileRounded } from "@mui/icons-material";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import ViewUserDocument from "./viewUserDocument";
import AddEditUserDocument from "./addEditUserDocument";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { BsFillPatchExclamationFill } from "react-icons/bs";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 1 }}>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function propsIndex(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
        value: index,
    };
}

export default function DocumentsMaster({ Show, handleClose, userId, kyc, onKycUpdate }) {
    const theme = useTheme();
    // eslint-disable-next-line
    const [local_Permission,] = React.useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) => (
                iPermission.permissionid === Constants.PERMISSIONS.MASTER_USER)
        )
    );
    // const [value, setValue] = React.useState((Utility.isUpdateAllowed(local_Permission)) || (Constants.loggedInUser.usertype === 'E') ? 0 : 1);
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        <Modal dialogClassName="bhb" show={Show} onHide={handleClose} enforceFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <img
                        src={logo}
                        height="40pt"
                        width="40pt"
                        alt={Constants.COMPANY_SITE}
                    />
                    &nbsp;&nbsp;
                    User Documents (User ID: {userId}){" "}
                    <Tooltip title={kyc ? "KYC Approved" : "KYC Pending"}>
                        <span
                            style={{
                                color: kyc ? "green" : "orange",
                                marginLeft: "8px",
                                cursor: "pointer",
                            }}
                        >
                            {kyc ? <BsFillPatchCheckFill /> : <BsFillPatchExclamationFill />}
                        </span>
                    </Tooltip>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box sx={{ bgcolor: "background.paper", width: "100%", padding: "10px" }}>
                    <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="secondary"
                            textColor="inherit"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                            sx={{
                                "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                                    color: "#212121",
                                    fontWeight: "bold",
                                    textAlign: 'center'
                                },
                                "& .MuiTab-root": {
                                    paddingBottom: 4
                                },
                                "& .Mui-selected": {
                                    bgcolor: "#0277bd !important",
                                    color: "#fafafa !important",
                                    fontWeight: "bold !important",
                                    paddingBottom: 4
                                }
                            }}
                            TabIndicatorProps={{ style: { background: "#0277bd" } }}
                        >
                            <Tab
                                icon={<PlagiarismRounded fontSize="large" />}
                                iconPosition="start"
                                label="View Document"
                                {...propsIndex(0)}
                            />
                            <Tab
                                icon={<UploadFileRounded fontSize="large" />}
                                iconPosition="start"
                                label="Add/Change Document"
                                {...propsIndex(1)}
                            />
                        </Tabs>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                    >
                        <TabPanel value={value} index={0}>
                            <ViewUserDocument userId={userId} onKycUpdate={onKycUpdate} kyc={kyc} />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <AddEditUserDocument userId={userId} />
                        </TabPanel>
                    </SwipeableViews>
                </Box>
            </Modal.Body>

        </Modal>
    )
}